/*
  Neropos, a scent's buy (sections/np-buy.liquid; design: themes/neropos/design/pages/product.js). The quantity and its
  price on every buy button (the prices themselves come from Liquid, the store's own), how long the boxes last, the
  free shipping line, «Αγορά» through the cart (np-cart.js: the drop flies into the bag, then the drawer), the gallery,
  and the box's swirl round the product in the colours of its box: it comes in drop by drop as the page opens, then
  rests, still; only the pointer stirs it like water, and a tap ripples it. A photo sends it out, the box brings it
  back. With reduced motion it simply shows, whole.
*/
(function () {
  'use strict';
  var NP = window.NP || {}, $ = NP.$, $$ = NP.$$, reduce = NP.reduce, tx = NP.tx;
  var band = $('[data-pbuy]'), dataEl = $('[data-np-product]');
  if (!band || !dataEl) return;
  var P = {};
  try { P = JSON.parse(dataEl.textContent); } catch (e) { P = {}; }
  var S = { n: Number(P.n) || 2 };
  var money = function (c) { return window.NPCart ? NPCart.money(c) : (c / 100).toFixed(2) + ''; };

  /* The quantity: its price on every buy button, how long the boxes last, the free shipping line */
  function sumOf(n) { var b = $('.qty [data-q="' + n + '"]'); return b ? Number(b.getAttribute('data-sum')) : (P.price || 0) * n; }
  function lasts(washes, wk) {
    var weeks = washes / wk;
    if (weeks < 9) { var w = Math.max(1, Math.floor(weeks)); return tx(w === 1 ? 'weeks_one' : 'weeks_other', { n: w }); }
    return tx('months', { n: Math.round(weeks / 4.345) });
  }
  function paintBuy() {
    var total = sumOf(S.n), free = Number(NP.free) || 0;
    $$('.qty [data-q]').forEach(function (b) {
      var n = Number(b.getAttribute('data-q')), tag = $('[data-freetag]', b);
      b.setAttribute('aria-checked', String(n === S.n));
      if (tag) tag.hidden = !free || Number(b.getAttribute('data-sum')) < free;
    });
    $$('[data-total]').forEach(function (el) { el.textContent = money(total); });
    var boxes = tx(S.n === 1 ? 'boxes_one' : 'boxes_other', { n: S.n });
    $$('[data-buylabel]').forEach(function (el) { el.setAttribute('aria-label', tx('buy_label', { word: tx('buy'), boxes: boxes, title: P.title || '', total: money(total) })); });
    $$('[data-qty-input]').forEach(function (el) { el.value = String(S.n); });
    var l = $('[data-lasts]');
    if (l) l.innerHTML = tx(S.n === 1 ? 'lasts_one_html' : 'lasts_other_html', { time: lasts((P.washes || 30) * S.n, 4) });
    var sh = $('[data-ship]');
    if (sh && free) sh.innerHTML = total >= free ? tx('ship_done_html') : tx('ship_from_html', { amount: money(free) });
  }
  $$('.qty [data-q]').forEach(function (b) { b.addEventListener('click', function () { S.n = Number(b.getAttribute('data-q')); paintBuy(); }); });
  // the arrows move the choice along the list, as in any group of choices
  var group = $('.qty[role="radiogroup"]');
  if (group) group.addEventListener('keydown', function (e) {
    var k = e.key, d = k === 'ArrowDown' || k === 'ArrowRight' ? 1 : k === 'ArrowUp' || k === 'ArrowLeft' ? -1 : 0;
    if (!d) return;
    e.preventDefault();
    S.n = Math.min(3, Math.max(1, S.n + d)); paintBuy();
    var b = $('[data-q="' + S.n + '"]', group); if (b) b.focus();
  });
  paintBuy();

  /* «Αγορά»: through the cart without leaving the page; without the cart script the form posts as it is */
  function buy(e, btn) {
    if (!window.NPCart || !P.variant) return;
    e.preventDefault();
    $$('[data-add]').forEach(function (b) { b.disabled = true; });
    NPCart.add(P.variant, S.n, { title: P.title }, btn)
      .catch(function (err) { NP.toast(err.shown || tx('error')); })
      .then(function () { $$('[data-add]').forEach(function (b) { b.disabled = false; }); });
  }
  var form = $('[data-pform]');
  if (form) form.addEventListener('submit', function (e) { buy(e, e.submitter || $('[data-add]', form)); });
  $$('[data-bar] [data-add]').forEach(function (b) { b.addEventListener('click', function (e) { buy(e, b); }); });

  /* The scents' line on a phone: it slides, and the edge that has more fades; the page's own scent starts in sight */
  $$('[data-pills]').forEach(function (row) {
    var cur = $('[aria-current="page"]', row), rr = row.getBoundingClientRect(), cr = cur && cur.getBoundingClientRect();
    if (cr && (cr.right > rr.right || cr.left < rr.left)) row.scrollLeft += cr.left + cr.width / 2 - (rr.left + rr.width / 2);
    function edges() { var x = row.scrollLeft, max = row.scrollWidth - row.clientWidth; row.classList.toggle('more-l', x > 2); row.classList.toggle('more-r', x < max - 2); }
    row.addEventListener('scroll', edges, { passive: true }); addEventListener('resize', edges); edges();
  });

  /* The gallery: the box with its swirl, or one of the photos */
  var stage = $('[data-stage]'), boxEl = $('[data-pbox]'), sw = $('[data-pswirl]'), photo = $('[data-pphoto]');
  $$('[data-gal]').forEach(function (b) {
    b.addEventListener('click', function () {
      var src = b.getAttribute('data-gal');
      $$('[data-gal]').forEach(function (x) { x.setAttribute('aria-current', String(x === b)); });
      if (src === 'box') { stage.setAttribute('data-mode', 'box'); go('in'); return; }
      var img = $('img', photo);
      if (!img) { img = document.createElement('img'); photo.appendChild(img); }
      img.removeAttribute('srcset'); img.src = src; img.alt = b.getAttribute('data-alt') || '';
      stage.setAttribute('data-mode', 'photo'); go('out');
    });
  });

  /* The swirl. g: where it sits on the band (its units to px; it is centred on the box, 2.3 times the box's height,
     never much wider than the band); scr: the part of the band seen when the page opens, which is where its pieces
     come in from (each starts just out of sight) */
  var SW = { E: null, cv: null, ctx: null, g: null, key: '', want: 'in', planned: false, raf: 0, ft: -1, t: 0, wn: 0, ptr: null, vis: true, live: false };
  function geom() {
    var br = band.getBoundingClientRect(), sr = stage.getBoundingClientRect(), bh = boxEl.offsetHeight, bw = boxEl.offsetWidth;
    if (!br.width || !bh) return false;
    var ss = Math.min(bh * 2.3, br.width * 1.05, sr.height * 1.45), k = ss / 1024;
    var cx = sr.left + sr.width / 2 - br.left, cy = sr.top + sr.height / 2 - br.top;
    var seen = Math.max(sr.bottom - br.top + 24, Math.min(br.height, innerHeight - Math.max(0, br.top)));
    SW.g = { W: br.width, H: Math.min(br.height, seen), CH: br.height, k: k, ox: cx - 512 * k, oy: cy - 512 * k, bw: bw / 2 / k, bh: bh / 2 / k };
    return true;
  }
  function scr() { var g = SW.g; return { l: -g.ox / g.k, r: (g.W - g.ox) / g.k, t: -g.oy / g.k, b: (g.H - g.oy) / g.k }; }
  function view() { var V = scr(), g = SW.g; V.box = { l: 512 - g.bw, r: 512 + g.bw, t: 512 - g.bh, b: 512 + g.bh }; V.far = scr(); return V; }
  function keyOf(V) { return [V.l, V.r, V.t, V.b, V.box.l, V.box.t].map(function (v) { return Math.round(v / 48); }).join(','); }
  function draw() {
    var g = SW.g, cv = SW.cv, ctx = SW.ctx, dpr = Math.min(2, window.devicePixelRatio || 1), w = Math.round(g.W * dpr), h = Math.round(g.CH * dpr);
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; cv.style.height = g.CH + 'px'; }
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, w, h);
    SW.E.draw(ctx, [g.k * dpr, g.ox * dpr, g.oy * dpr]);
  }
  function still() { SW.E.frame({ t: SW.t, now: SW.t, dt: 0, wnow: SW.wn, scr: scr() }); draw(); }
  // its frames run only while something on it moves (a piece on its way or settling, the water under the pointer)
  function run() {
    var E = SW.E, live = !!E && SW.planned && !reduce && SW.vis && (E.moving() || !!SW.ptr || E.busy());
    if (!live) SW.ft = -1;
    SW.live = live;
    if (live && !SW.raf) SW.raf = requestAnimationFrame(tick);
  }
  function tick(ts) {
    SW.raf = 0; if (!SW.live) return;
    var dt = SW.ft < 0 ? 0 : Math.min(.1, (ts - SW.ft) / 1000); SW.ft = ts;
    SW.t += dt; SW.wn += dt;
    SW.E.waterStep(SW.ptr, SW.wn, dt);
    SW.E.frame({ t: SW.t, now: SW.t, dt: dt, wnow: SW.wn, scr: scr() });
    draw(); run();
  }
  function go(want) {
    SW.want = want;
    if (!SW.E || !SW.planned) return;
    if (reduce) { sw.classList.toggle('on', want === 'in'); return; }
    if (want === 'in') SW.E.enter(SW.t, false); else { SW.ptr = null; SW.E.leave(SW.t, false); }
    run();
  }
  // its lanes, worked out a few milliseconds a frame so the page never stalls
  function plan(done) {
    var V = view(), key = keyOf(V), step = SW.E.planSteps(V);
    (function chunk() {
      var t0 = performance.now();
      while (performance.now() - t0 < 10) if (step()) { SW.key = key; SW.planned = true; done(); return; }
      requestAnimationFrame(chunk);
    })();
  }
  // the swirl in the box's own colours: each colour of its pieces takes the same lightness on the page's ramp (--swirl,
  // from its deepest colour to its lightest: White Linen's beige and gold, Sensitive's mint), so every piece keeps its
  // light and shade. Aegean Fresh has no ramp: its swirl keeps the box's own blues
  function rgb(c) { var v = parseInt(c.slice(1), 16); return [v >> 16, (v >> 8) & 255, v & 255]; }
  function lum(c) { return (.2126 * c[0] + .7152 * c[1] + .0722 * c[2]) / 255; }
  function tint(d) {
    var ramp = (getComputedStyle(band).getPropertyValue('--swirl') || '').split(' ').filter(function (c) { return /^#[0-9a-fA-F]{6}$/.test(c); }).map(rgb);
    if (ramp.length < 2) return d;
    var src = JSON.stringify(d), lo = 1, hi = 0, HEX = /#[0-9a-fA-F]{6}/g;
    src.replace(HEX, function (c) { var y = lum(rgb(c)); if (y < lo) lo = y; if (y > hi) hi = y; return c; });
    var h2 = function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); };
    return JSON.parse(src.replace(HEX, function (c) {
      var t = (lum(rgb(c)) - lo) / ((hi - lo) || 1) * (ramp.length - 1), i = Math.min(ramp.length - 2, Math.floor(t)), f = t - i, a = ramp[i], b = ramp[i + 1];
      return '#' + h2(a[0] + (b[0] - a[0]) * f) + h2(a[1] + (b[1] - a[1]) * f) + h2(a[2] + (b[2] - a[2]) * f);
    }));
  }
  function build() {
    var d = window.NEROPOS_SWIRL3; if (SW.E || !d || !window.NeroSwirl12 || !sw || !boxEl) return;
    try { SW.E = window.NeroSwirl12(tint(d), {}); } catch (err) { SW.E = null; return; }
    SW.cv = document.createElement('canvas'); SW.ctx = SW.cv.getContext('2d'); sw.appendChild(SW.cv);
    if (!geom()) return;
    if (reduce) {
      sw.classList.add('still');
      var V = view(); SW.E.plan(V); SW.key = keyOf(V); SW.planned = true; SW.E.settle(); still();
      sw.classList.toggle('on', SW.want === 'in');
      return;
    }
    plan(function () { setTimeout(function () { go(SW.want); }, 120); });
  }
  // its pieces (np-swirl3.js, the box's swirl as data) load once the page has
  function load() {
    if (window.NEROPOS_SWIRL3) { build(); return; }
    var url = band.getAttribute('data-swirl-src'); if (!url) return;
    var s = document.createElement('script'); s.src = url; s.async = true; s.onload = build; document.head.appendChild(s);
  }
  function start() { (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(load); }
  if (document.readyState === 'complete') start(); else addEventListener('load', start);
  // a new size: where it sits again, its lanes again if the band changed shape, and one still frame
  var rT = 0;
  var resized = function () {
    if (!SW.E || !SW.planned) return;
    geom();
    var V = view(), key = keyOf(V);
    if (key !== SW.key) { SW.E.plan(V); SW.key = key; }
    if (!SW.live) still();
  };
  addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(resized, 120); });
  if (window.ResizeObserver) new ResizeObserver(function () { clearTimeout(rT); rT = setTimeout(resized, 60); }).observe(band);
  if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { SW.vis = es[0].isIntersecting; run(); }).observe(band);
  // the reader's hand in the water: a mouse stirs it as it passes, a tap ripples it
  if (!reduce) {
    var at = function (ev) { var r = band.getBoundingClientRect(); return [(ev.clientX - r.left - SW.g.ox) / SW.g.k, (ev.clientY - r.top - SW.g.oy) / SW.g.k]; };
    band.addEventListener('pointermove', function (ev) { if (ev.pointerType === 'touch' || !SW.planned || SW.want !== 'in') return; SW.ptr = at(ev); run(); });
    band.addEventListener('pointerleave', function () { SW.ptr = null; run(); });
    stage.addEventListener('pointerdown', function (ev) { if (!SW.planned || SW.want !== 'in') return; var p = at(ev); SW.E.tap(p[0], p[1]); run(); });
  }
  // for the page's checks
  window.__pdpSwirl = function () { return SW.E ? { planned: SW.planned, live: SW.live, moving: SW.E.moving(), modes: SW.E.modes(), g: SW.g } : null; };
})();
